import individual from "../assets/individual-effectiveness.svg"
import team from "../assets/team-effectiveness.svg"
import recommended from "../assets/recommended-thumb.svg"
import filled_star from "../assets/teams-filled-star.svg"
import empty_star from "../assets/teams-empty-star.svg"
import teams_api from "../api/protected/teams"
import profile_api from "../api/protected/profile";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import info from "../assets/info-icon.png";
import Slider from "./Slider";
import tick from "../assets/dashboard-roi-tick.svg";
import dashboard_api from "../api/protected/dashboard";
import roi_icon from "../assets/dashboard-roi.svg";
import expand from "../assets/expand-teams.svg";
import collapse from "../assets/collapse.svg";
import SubscriptionNeededPopup from "../components/SubscriptionNeededPopup";


const EditTeamFeedbackContainer = (props) => {
    const navigate = useNavigate();

    const [feedback, setFeedback] = useState(null)
    const starMap = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const [roiData, setRoiData] = useState(null)
    const [showBenchmark, setShowBenchmark] = useState(true)
    const [showCategoryBenchmark, setShowCategoryBenchmark] = useState(false)
    const [showPlatformHover, setShowPlatformHover] = useState(false)
    const [showFeedbackRatingsHover, setShowFeedbackRatingsHover] = useState(false)
    const [showTeamEffectivenessHover, setShowTeamEffectivenessHover] = useState(false)
    const [showIndividualHover, setShowIndividualHover] = useState(false)
    const [showRecommendedHover, setShowRecommendedHover] = useState(false)
    const [showPerformanceHover, setShowPerformanceHover] = useState(false)
    const [collapsed, setCollapsed] = useState(false)
    const [hideRatings, setHideRatings] = useState(false)
    // No data popups
    const [showNoDataROI, setShowNoDataROI] = useState(false)
    const [showNoDataFeedback, setShowNoDataFeedback] = useState(false)

    const [subscription, setSubscription] = useState(null);
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);


    const getTeamFeedback = () => {
        let response = teams_api.getTeamFeedback(props.team_id);
        response.then(response => {
            setFeedback(response.data)
        }).catch(err => console.log(err))
    }

    const getCoachROI = () => {
        let response = teams_api.getTeamROIData(props.team_id);
        response.then(response => {
            setRoiData(response.data)
        }).catch(err => console.log(err))
    }

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        getSubscription();
    }, []);

    useEffect(() => {
        if (subscription < 1) {
            setHideRatings(true);
        }
        else {
            setHideRatings(false);
        }
    }, [subscription]);

    const handleROIClick = () => {
        if (roiData?.user_count === 0) return;
        if (subscription === null) return;

        if (subscription < 1) {
            setShowSubscriptionPopup(true);
            return;
        }

        navigate("/roireport");
    };

    useEffect(() => {
        if(!props.team_id) return;
        getTeamFeedback()
        getCoachROI()
    }, [props.team_id]);

    const calculateIncrease = () => {
        if(!feedback) return;
        if(!feedback.initial_avg) return feedback.endpoint_avg
        let increase = feedback.endpoint_avg - feedback.initial_avg
        return Math.round((increase / feedback.initial_avg) * 100)
    }

    const handleCollapse = (ev) => {
        if(!ev) return;
        setCollapsed(!collapsed)
    }

    const hasCategoryBenchmark = Boolean(roiData?.category_name)
    const categoryBenchmarkLabel = roiData?.category_name
        ? `Add ${roiData.category_name} benchmarking data`
        : ""


    return (
        <div className={`edit-team-feedback-container ${collapsed ? "collapsed" : ""}`} style={{display: props.isDemo ? "none" : "block"}}>
            <div className="dashboard-roi-details-row">
                <div className="dashboard-roi-details-main">
                    <div className="dashboard-roi-details-text regular">Responses included:</div>
                    <div className="dashboard-roi-details-responses-text regular">Total Participants:</div>
                    <div className="dashboard-roi-details-responses-text bold">{roiData?.user_count}</div>
                </div>
                <div className={"dashboard-roi-details-report-button bold" + (roiData?.user_count === 0 ? " no-data" : "")}
                     onClick={handleROIClick}
                     onMouseOver={()=> setShowNoDataROI(true)}
                     onMouseOut={()=> setShowNoDataROI(false)}>
                    <div className="button-text">SEE DETAILS</div>
                    <img src={roi_icon} alt="See details"/>
                    {showNoDataROI && roiData?.user_count === 0 ?
                        <div className="edit-team-no-data-popup">
                            No data available
                        </div> : null
                    }
                </div>
                <div className={`edit-team-feedback-collapse ${collapsed ? "collapsed" : ""}`} onClick={handleCollapse}>
                    <img src={collapsed ? expand : collapse} alt={collapsed ? "Show performance details" : "Hide performance details"}/>
                </div>
            </div>
            {!collapsed ?
                <>
                    <div className="edit-team-feedback-main">
                        {!hideRatings ?
                            <div className="edit-team-feedback-left">
                                <div className="edit-team-feedback-title margined bold">Feedback Ratings
                                    <img src={info} alt="Info"
                                         onMouseOver={() => setShowFeedbackRatingsHover(true)}
                                         onMouseLeave={() => setShowFeedbackRatingsHover(false)}
                                    />
                                </div>
                                {showFeedbackRatingsHover ?
                                    <div className="dashboard-roi-title-hover" style={{top: 60, left: 150}}>
                                        <div className="dashboard-roi-title-hover-triangle-outer">
                                            <div className="dashboard-roi-title-hover-triangle-inner"/>
                                        </div>
                                        <div className="dashboard-roi-title-hover-text regular">
                                            This section looks at the collated ratings given by all your responding team
                                            participants on how they feel the Team Coach has impacted performance.
                                        </div>
                                    </div> : null
                                }
                                <div className="edit-team-feedback-rating-container">
                                    <div className="edit-team-feedback-rating-icon">
                                        <img src={individual} alt="Individual improvement"/>
                                    </div>
                                    <div className="edit-team-feedback-rating-main">
                                        <div className="edit-team-feedback-rating-title regular">
                                            <span className="bold">TEAM</span> COMMUNICATION & EFFECTIVENESS
                                            <img src={info} alt="Info"
                                                 onMouseOver={() => setShowTeamEffectivenessHover(true)}
                                                 onMouseLeave={() => setShowTeamEffectivenessHover(false)}
                                            />
                                        </div>
                                        {showTeamEffectivenessHover ?
                                            <div className="dashboard-roi-title-hover" style={{top: 105, left: 303}}>
                                                <div className="dashboard-roi-title-hover-triangle-outer">
                                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                                </div>
                                                <div className="dashboard-roi-title-hover-text regular">
                                                    Ratings received for the statement “The Team Coach(es) positively influenced
                                                    the communication and effectiveness <span className="underline">of the team as a whole</span>?”
                                                </div>
                                            </div> : null
                                        }
                                        <div className="edit-team-feedback-rating-stars-container">
                                            {starMap.map(idx => {
                                                return (
                                                    <div className="feedback-rating-star-container" key={idx}>
                                                        <div className="feedback-rating-star">
                                                            {feedback?.question_response_1 >= idx ?
                                                                <img src={filled_star} alt="Star"/>
                                                                :
                                                                <img src={empty_star} alt="Star"/>
                                                            }
                                                        </div>
                                                        <div className="feedback-rating-number bold">{idx}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="edit-team-feedback-rating-container">
                                    <div className="edit-team-feedback-rating-icon">
                                        <img src={team} alt="Individual improvement"/>
                                    </div>
                                    <div className="edit-team-feedback-rating-main">
                                        <div className="edit-team-feedback-rating-title regular">
                                            <span className="bold">INDIVIDUAL</span> COMMUNICATION & EFFECTIVENESS
                                            <img src={info} alt="Info"
                                                 onMouseOver={() => setShowIndividualHover(true)}
                                                 onMouseLeave={() => setShowIndividualHover(false)}
                                            />
                                        </div>
                                        {showIndividualHover ?
                                            <div className="dashboard-roi-title-hover" style={{top: 220, left: 344}}>
                                                <div className="dashboard-roi-title-hover-triangle-outer">
                                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                                </div>
                                                <div className="dashboard-roi-title-hover-text regular">
                                                    Ratings received for the statement “The Team Coach(es) positively influenced
                                                    the communication and effectiveness <span className="underline">of you personally within this team</span>?”
                                                </div>
                                            </div> : null
                                        }
                                        <div className="edit-team-feedback-rating-stars-container">
                                            {starMap.map(idx => {
                                                return (
                                                    <div className="feedback-rating-star-container" key={idx}>
                                                        <div className="feedback-rating-star">
                                                            {feedback?.question_response_2 >= idx ?
                                                                <img src={filled_star} alt="Star"/>
                                                                :
                                                                <img src={empty_star} alt="Star"/>
                                                            }
                                                        </div>
                                                        <div className="feedback-rating-number bold">{idx}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="edit-team-feedback-rating-container">
                                    <div className="edit-team-feedback-rating-icon">
                                        <img src={recommended} alt="Individual improvement"/>
                                    </div>
                                    <div className="edit-team-feedback-rating-main">
                                        <div className="edit-team-feedback-rating-title regular">
                                            <span className="bold">INDIVIDUAL</span>TEAM COACH RECOMMENDATION
                                            <img src={info} alt="Info"
                                                 onMouseOver={() => setShowRecommendedHover(true)}
                                                 onMouseLeave={() => setShowRecommendedHover(false)}
                                            />
                                        </div>
                                        {showRecommendedHover ?
                                            <div className="dashboard-roi-title-hover" style={{top: 315, left: 325}}>
                                                <div className="dashboard-roi-title-hover-triangle-outer">
                                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                                </div>
                                                <div className="dashboard-roi-title-hover-text regular">
                                                    Ratings received for the statement “I would recommend the Team Coach(es) to
                                                    another team?”
                                                </div>
                                            </div> : null
                                        }
                                        <div className="edit-team-feedback-rating-stars-container">
                                            {starMap.map(idx => {
                                                return (
                                                    <div className="feedback-rating-star-container" key={idx}>
                                                        <div className="feedback-rating-star">
                                                            {feedback?.question_response_3 >= idx ?
                                                                <img src={filled_star} alt="Star"/>
                                                                :
                                                                <img src={empty_star} alt="Star"/>
                                                            }
                                                        </div>
                                                        <div className="feedback-rating-number bold">{idx}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-roi-title bold margined">
                                    Platform Recommendation
                                    <img src={info} alt="Info"
                                         onMouseOver={() => setShowPlatformHover(true)}
                                         onMouseLeave={() => setShowPlatformHover(false)}
                                    />
                                </div>
                                {showPlatformHover ?
                                    <div className="dashboard-roi-title-hover" style={{top: 440, left: 237}}>
                                        <div className="dashboard-roi-title-hover-triangle-outer">
                                            <div className="dashboard-roi-title-hover-triangle-inner"/>
                                        </div>
                                        <div className="dashboard-roi-title-hover-text regular">
                                            The below score is the collated ratings score given by all your responding team
                                            participants to the following statement: “I would recommend PERILL Diagnostics for
                                            Teams to another team”.
                                        </div>
                                    </div> : null
                                }
                                <div className="edit-team-feedback-rating-container dashboard platform">
                                    <div className="edit-team-feedback-rating-main">
                                        <div className="edit-team-feedback-rating-stars-container">
                                            {starMap.map(idx => {
                                                return (
                                                    <div className="feedback-rating-star-container" key={idx}>
                                                        <div className="feedback-rating-star">
                                                            <img src={roiData?.platform_recommended >= idx ? filled_star : empty_star}
                                                                 alt="Star"/>
                                                        </div>
                                                        <div className="feedback-rating-number bold">{idx}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                        <div className={`dashboard-roi-main-right ${hideRatings ? "full-width" : ""}`}>
                            <div className="dashboard-roi-right-title-container">
                                <div className="dashboard-roi-title bold">
                                    Performance Over Time
                                    <img src={info} alt="Info"
                                         onMouseOver={() => setShowPerformanceHover(true)}
                                         onMouseLeave={() => setShowPerformanceHover(false)}
                                    />
                                </div>
                                {showPerformanceHover ?
                                    <div className="dashboard-roi-title-hover" style={{top: 40, left: 210}}>
                                        <div className="dashboard-roi-title-hover-triangle-outer">
                                            <div className="dashboard-roi-title-hover-triangle-inner"/>
                                        </div>
                                        <div className="dashboard-roi-title-hover-text regular">
                                            This table shows your combined aggregated PERILL scores (and function level) for
                                            your teams* over time – including the overall percentage change. You can also
                                            toggle on the benchmarking data to compare your teams performance metrics with
                                            other teams across the platform.
                                            <br/><br/>
                                            *at least two initial and end point responses per team are required to qualify.
                                        </div>
                                    </div> : null
                                }
                            </div>
                            <div className="dashboard-roi-chart-container edit-team-roi-chart">
                                <div className="dashboard-roi-thermometer-heading regular">START OF COACHING ENGAGEMENT</div>
                                <div className="dashboard-roi-thermometer-container">
                                    <div className="dashboard-roi-thermometer-score-circle bold"
                                         style={{ left: `${(roiData?.initial_score / 50) * 100}%` }}>
                                        {roiData?.initial_score}
                                    </div>
                                    {showBenchmark ?
                                        <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                             style={{ left: `${(roiData?.benchmark_initial / 50) * 100}%` }}>
                                            {roiData?.benchmark_initial}
                                        </div> : null
                                    }
                                    {hasCategoryBenchmark && showCategoryBenchmark ?
                                        <div className="dashboard-roi-thermometer-score-circle benchmark category bold"
                                             style={{ left: `${(roiData?.category_benchmark_initial / 50) * 100}%` }}>
                                            {roiData?.category_benchmark_initial}
                                        </div> : null
                                    }
                                    <div className="dashboard-roi-thermometer-outer-band">
                                        <div className="dashboard-roi-thermometer-inner-band">
                                            <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                            <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                            <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-roi-thermometer-markings-container bold">
                                    <div className="dashboard-roi-thermometer-marking">0</div>
                                    <div className="dashboard-roi-thermometer-marking">50</div>
                                </div>
                                <div className="dashboard-roi-vs bold">VS</div>
                                <div className="dashboard-roi-thermometer-heading regular top-margin">END OF COACHING ENGAGEMENT</div>
                                <div className="dashboard-roi-thermometer-container">
                                    <div className="dashboard-roi-thermometer-score-circle bold"
                                         style={{ left: `${(roiData?.endpoint_score / 50) * 100}%` }}>
                                        {roiData?.endpoint_score}
                                    </div>
                                    {showBenchmark ?
                                        <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                             style={{ left: `${(roiData?.benchmark_end / 50) * 100}%` }}>
                                            {roiData?.benchmark_end}
                                        </div>
                                        : null
                                    }
                                    {hasCategoryBenchmark && showCategoryBenchmark ?
                                        <div className="dashboard-roi-thermometer-score-circle benchmark category bold"
                                             style={{ left: `${(roiData?.category_benchmark_end / 50) * 100}%` }}>
                                            {roiData?.category_benchmark_end}
                                        </div> : null
                                    }
                                    <div className="dashboard-roi-thermometer-outer-band">
                                        <div className="dashboard-roi-thermometer-inner-band">
                                            <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                            <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                            <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-roi-thermometer-markings-container bold">
                                    <div className="dashboard-roi-thermometer-marking">0</div>
                                    <div className="dashboard-roi-thermometer-marking">50</div>
                                </div>
                                <div className={`dashboard-roi-performance-change-container${hasCategoryBenchmark && showCategoryBenchmark ? " with-category" : ""}`}>
                                    <div className="dashboard-roi-performance-container">
                                        <div className="dashboard-roi-performance-title regular">PERFORMANCE % CHANGE</div>
                                        <div className="dashboard-roi-performance-value-container bold">
                                            {roiData && (roiData.coach_improvement === -100 ?
                                                    (<>N/A</>)
                                                    : (
                                                        <>
                                                            {roiData.coach_improvement}
                                                            <span>%</span>
                                                            <img src={tick} alt="Improvement" className="dashboard-roi-performance-tick"/>
                                                        </>
                                                    )
                                            )}
                                        </div>
                                    </div>
                                    {showBenchmark ? <div className="dashboard-roi-performance-divider"/> : null}
                                    {showBenchmark ?
                                        <div className="dashboard-roi-performance-container">
                                            <div className="dashboard-roi-performance-title regular">BENCHMARK % CHANGE</div>
                                            <div className="dashboard-roi-performance-value-container benchmark bold">
                                                {roiData?.benchmark_improvement}<span>%</span>
                                            </div>
                                        </div> : null
                                    }
                                    {hasCategoryBenchmark && showCategoryBenchmark ?
                                        <div className="dashboard-roi-performance-divider"/> : null
                                    }
                                    {hasCategoryBenchmark && showCategoryBenchmark ?
                                        <div className="dashboard-roi-performance-container">
                                            <div className="dashboard-roi-performance-title regular">
                                                {roiData.category_name.toUpperCase()} % CHANGE
                                            </div>
                                            <div className="dashboard-roi-performance-value-container benchmark category bold">
                                                {roiData?.category_benchmark_improvement}<span>%</span>
                                            </div>
                                        </div> : null
                                    }
                                </div>
                                <div className="edit-team-roi-benchmark-footer">
                                    <div className="edit-team-roi-benchmark-footer-slot">
                                        {hasCategoryBenchmark ?
                                            <>
                                                <Slider state={showCategoryBenchmark}
                                                        update={setShowCategoryBenchmark.bind(this)}/>
                                                <div className="dashboard-roi-slider-text medium">
                                                    {categoryBenchmarkLabel}
                                                </div>
                                            </> : null
                                        }
                                    </div>
                                    <div className="edit-team-roi-benchmark-footer-slot right">
                                        <Slider state={showBenchmark} update={setShowBenchmark.bind(this)}/>
                                        <div className="dashboard-roi-slider-text medium">Add benchmarking data</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!hideRatings ?
                        <div className="edit-team-feedback-reviews-container">
                            <div className="edit-team-feedback-title bold">Latest Feedback Reviews</div>
                            <div className="edit-team-feedback-response-container">
                                <div className="edit-team-feedback-question regular">
                                    What would have made the team coaching experience more valuable for you?
                                </div>
                                <div className="edit-team-feedback-response regular">{feedback && feedback.question_response_4}</div>
                            </div>
                            <div className="edit-team-feedback-response-container">
                                <div className="edit-team-feedback-question regular">
                                    What was the most confusing or challenging part of the team coaching experience?
                                </div>
                                <div className="edit-team-feedback-response regular">{feedback && feedback.question_response_5}</div>
                            </div>
                            <div className="edit-team-feedback-response-container">
                                <div className="edit-team-feedback-question regular">
                                    Is there anything else you think we should know?
                                </div>
                                <div className="edit-team-feedback-response regular">{feedback && feedback.question_response_6}</div>
                            </div>
                            <div className="edit-team-feedback-button-container">
                                <div className={"edit-team-feedback-button bold" + (feedback?.question_response_1 === 0 ? " no-data" : "")}
                                     onClick={() => (feedback?.question_response_1 === 0 ? null : navigate(`/feedback/${props.team_id}`))}
                                     onMouseOver={()=> setShowNoDataFeedback(true)}
                                     onMouseOut={()=> setShowNoDataFeedback(false)}>
                                    SEE ALL REVIEWS</div>
                                {showNoDataFeedback && feedback?.question_response_1 === 0 ?
                                    <div className="edit-team-no-data-popup">
                                        No data available
                                    </div> : null
                                }
                            </div>
                        </div>
                        : null
                    }
                </> : null
            }
            {showSubscriptionPopup && (
                <SubscriptionNeededPopup
                    onClose={() => setShowSubscriptionPopup(false)}
                />
            )}
        </div>
    )
}


export default EditTeamFeedbackContainer